import { LiftoffMappingGroups } from "./liftoff-mapping/mappings";

export const PATHS = {
	NOPERMISSION: "/nopermission",
	EMPLOYEE_MANAGEMENT: "/employee_management",
	EMPLOYEES: "/employee_management/employees",
	SCHEDULED: "/employee_management/effective_dating",
	PROJECTOR: "/projector",
	PTO: "/projector/pto",
	D365: "/d365",
	D365_EXPORTS: "/d365/exports",
	D365_ADJUSTMENTS: "/d365/adjustments",
	D365_ADJUSTMENTS_UPLOADS: "/d365/adjustments/uploads",
	D365_ADJUSTMENTS_ALL: "/d365/adjustments/all",
	D365_EXPENSES: "/d365/expenses",
	D365_EXPENSES_PROCESSED: "/d365/expenses/processed",
	D365_EXPENSES_PROJECTOR_EXPENSE_TYPES: "/d365/expenses/projectorExpenseTypes",
	D365_EXPENSES_CODES: "/d365/expenses/codes",
	D365_EXPENSES_FILES: "/d365/expenses/files",
	D365_EXPENSES_MAPPINGS: "/d365/expenses/mappings",
	D365_EXPENSES_UNFOUND_PROJECTS: "/d365/expenses/unfoundProjects",
	D365_HOURS: "/d365/hours",
	D365_RATES: "/d365/rates",
	D365_WORKERS: "/d365/workers",
	D365_HOUR_LOG_PERIODS: "/d365/hour_log_periods",
	D365_PROJECT_SEARCH: "/d365/project_search",
	D365_PAYMENTS: "/d365/payments",
	LIFTOFF: "/liftoff",
	LIFTOFF_MAPPING: "/liftoff/mapping",
	LIFTOFF_USERS: "/liftoff/users",
	LOA: "/projector/loa",
	GET_EMPLOYEES_BULK: "/employees_bulk",
	DOWNLOAD_EMPLOYEE_BULK_TEMPLATE: "/download_employees_bulk_template",
	SUBMIT_EMPLOYEES_BULK: "/submit_employees_bulk",
};

export const PSA_INSTANCE = [
	{ label: "CREDERA", value: "CREDERA" },
	{ label: "LEAPPOINT", value: "LEAPPOINT" },
	{ label: "TA DIGITAL", value: "TAD" },
];

// Add Liftoff Mapping paths
LiftoffMappingGroups.forEach((group) => {
	group.mappings.forEach((m) => {
		PATHS[`LIFTOFF_MAPPING_${group.group}_${m.entity}`] =
			`${PATHS.LIFTOFF_MAPPING}/${group.group}/${m.entity}`;
	});
});

export const VALID_PROJECT_CODE = new RegExp(
	"^(([P]\\d{6}|[R]\\d{4})-\\d{3}|(?:CRED|LP01|LP02|JS01|CA04|IN24)-P\\d{8})|(TAPROJ-\\d{3,5})$",
);
export const ANY_REGEXP = new RegExp("^.*$");
